import React from 'react';
import { Link } from 'react-router-dom';
import ProductCard from '../components/ProductCard/ProductCard';
import { products } from '../data/product_catalog';
import './Home.css';

const Home = () => {
  const categories = [
    { id: 'dresses', name: 'Baby', image: 'https://dgmart-images.s3.us-east-2.amazonaws.com/il_1588xN.7245805791_no07.webp' },
    { id: 'rompers', name: 'Toddler', image: 'https://dgmart-images.s3.us-east-2.amazonaws.com/il_1588xN.7245805791_no07.webp' },
    { id: 'accessories', name: 'Accessories', image: 'https://dgmart-images.s3.us-east-2.amazonaws.com/il_1588xN.7245805791_no07.webp' }
  ];

  const newArrivals = products.slice(0, 4);

  return (
    <div className="home">
      <section className="hero">
        <div className="hero-content">
          <span className="hero-subtitle">New Collection 2024</span>
          <h1>Elegance in Every Bloom & Stitch</h1>
          <p>Discover our curated collection of preserved flowers and timeless children's apparel, designed with love and care.</p>
          <div className="hero-actions">
            <Link to="/shop" className="btn btn-primary">Shop Collection</Link>
            <Link to="/about" className="btn btn-outline" style={{ marginLeft: '20px', backgroundColor: 'transparent' }}>Our Story</Link>
          </div>
        </div>
      </section>

      <section className="benefits">
        <div className="container">
          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="benefit-icon">🌿</div>
              <h3>Sustainable</h3>
              <p>Ethically sourced and eco-friendly materials only.</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">✨</div>
              <h3>Handcrafted</h3>
              <p>Each piece is carefully designed and finished by hand.</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">🚚</div>
              <h3>Free Shipping</h3>
              <p>On all orders over $100 within the continental US.</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">💝</div>
              <h3>Gift Ready</h3>
              <p>Beautiful premium packaging included with every order.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="featured-categories">
        <div className="container">
          <h2 className="section-title">Shop by Category</h2>
          <div className={`category-grid count-${categories.length}`}>
            {categories.map((cat) => (
              <div className="category-card" key={cat.id}>
                <Link to={`/shop?category=${cat.id}`}>
                  <div className="category-image">
                    <img src={cat.image} alt={cat.name} />
                  </div>
                  <h3>{cat.name}</h3>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="new-arrivals">
        <div className="container">
          <h2 className="section-title">New Arrivals</h2>
          <div className="products-grid">
            {newArrivals.map(product => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
          <div className="center" style={{ marginTop: '40px' }}>
            <Link to="/shop" className="btn btn-outline">
              View All Products
            </Link>
          </div>
        </div>
      </section>

      <section className="about-preview">
        <div className="container">
          <div className="about-flex">
            <div className="about-content">
              <span className="hero-subtitle">Since 2020</span>
              <h2>Our Story</h2>
              <p>Discover the magic of childhood through our carefully curated collection 
                 of timeless clothing and accessories. We believe that every child deserves 
                 to wear something as special as they are.</p>
              <p>Epoxy Garden was born from a passion for beautiful design and a commitment 
                 to quality that lasts through every adventure.</p>
              <Link to="/about" className="btn btn-outline">Learn More</Link>
            </div>
            <div className="about-image">
              <img src="https://framedliquor.com/cdn/shop/files/Lijst_33_x_43_4.png?v=1712220829&width=1646" alt="About Epoxy Garden" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
